/**
 * Created by mateimisarca on 17/09/2020
 */

import { createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';

export const updateUi = createAction('app/UI/updateUI');
export const resetUi = createAction('app/UI/resetUi');
export const pageView = createFormAction('app/UI/pageView');